import React from "react";
import ReactECharts from 'echarts-for-react';
import _ from "lodash";
import PropTypes from 'prop-types';

const YTCurrentchart = (props) => {
    const {
        IsChartMultiple,
Yearcost,
chartcolor,
chartheight,
color,
cost,
data,
isScroll,
isScrollEndLimit,
isScrollStartLimit,
scrollBarBottomAlign,
xAxisData,
yField
    } = props;


    const getLineOption = () => {
        let options = {
            xAxis: {
                show: false,
                type: 'category',
                boundaryGap: false,
                data: xAxisData,
            },
            yAxis: {
                show: false,
                type: 'value'
            },
            grid: {
                top: "0%",
                left: "-4%",
                right: "-4%",
                bottom: "8%",
                containLabel: true,
            },
            graphic: [
                {
                    type: 'text',
                    left: 'center',
                    top: 'middle',
                    style: {
                        text: cost,
                        textAlign: 'center',
                        fill: color,
                        font: 'bold 35px Arial'
                    },
                    z: 10
                },
                {
                    type: 'text',
                    left: 'center',
                    bottom: '20%',
                    style: {
                        text: Yearcost,
                        textAlign: 'center',
                        fill: '#000',
                        font: '14px Arial'
                    }, z: 10

                }
            ],
            series: [
                {
                    color: chartcolor,
                    lineStyle: {
                        width: 0
                    },
                    data: data,
                    type: 'line',
                    symbol: 'none',
                    areaStyle: {}
                }
            ]
        };
        if (isScroll) {
            options.dataZoom = [
                {
                    type: 'slider',
                    start: isScrollStartLimit ? isScrollStartLimit : 0,
                    end: isScrollEndLimit ? isScrollEndLimit : 30,
                    height: 15,
                    bottom: scrollBarBottomAlign ? scrollBarBottomAlign : 15,
                    showDetail: false,
                    handleStyle: {
                        color: color[0],
                    },
                    dataBackground: {
                        lineStyle: {
                            color: color[0]
                        },
                        areaStyle: {
                            color: 'rgba(255, 0, 0, 0.1)'
                        }
                    }
                },
                {
                    type: 'inside',
                    start: 0,
                    end: 30
                },
            ];
        }
        if (isScroll) {
            options.dataZoom = [
                {
                    type: 'slider',
                    start: isScrollStartLimit ? isScrollStartLimit : 0,
                    end: isScrollEndLimit ? isScrollEndLimit : 30,
                    height: 15,
                    bottom: scrollBarBottomAlign ? scrollBarBottomAlign : 15,
                    showDetail: false,
                    handleStyle: {
                        color: color[0],
                    },
                    dataBackground: {
                        lineStyle: {
                            color: color[0]
                        },
                        areaStyle: {
                            color: 'rgba(255, 0, 0, 0.1)'
                        }
                    }
                },
                {
                    type: 'inside',
                    start: 0,
                    end: 30
                },
            ];
        }
        return options;
    };

    return (
        <div style={{ height: chartheight ? chartheight : null }}>
            <div className={!IsChartMultiple ? "yAxispositioningLinechart" : "yAxispositioningLinechartMultiple"}>{yField}</div>
            <ReactECharts option={getLineOption()} onEvents={""} style={{ height: "163px", width: "19vw" }} />
        </div>
    );
};

function areEqual(prevProps, nextProps) {
    if (_.isEqual(prevProps.showLegend, nextProps.showLegend) &&
        _.isEqual(prevProps.events, nextProps.events) &&
        _.isEqual(prevProps.isScroll, nextProps.isScroll) &&
        _.isEqual(prevProps.countTitle, nextProps.countTitle) &&
        _.isEqual(prevProps.spaceLeft, nextProps.spaceLeft) &&
        _.isEqual(prevProps.spaceRight, nextProps.spaceRight) &&
        _.isEqual(prevProps.spaceTop, nextProps.spaceTop)) {
        return true;
    } else {
        return false;
    }
}

YTCurrentchart.propTypes = {
  IsChartMultiple: PropTypes.bool,
  Yearcost: PropTypes.string,
  chartcolor: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  chartheight: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  color: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  cost: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.object
    ])
  ),
  isScroll: PropTypes.bool,
  isScrollEndLimit: PropTypes.number,
  isScrollStartLimit: PropTypes.number,
  scrollBarBottomAlign: PropTypes.number,
  xAxisData: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ])
  ),
  yField: PropTypes.string
};

export default React.memo(YTCurrentchart, areEqual);


